// ##############################
// ### Constants for App Context
// ##############################
export const webClockContextKeys = Object.freeze({
  OFFLINE_PUNCHES: 'OfflinePunches',
});
